import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/styles.scss';
import App from './App';
import { AppConfig } from './utils/config-store';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <AppConfig>
    <App />
  </AppConfig>
);
